import React from "react";
import LoginStepComponent from "./components/login.component";
import { useCreateAcincoContext } from "./provider/createAcinco.provider";
import Code2FAStepComponent from "./components/code.component";
import CreateNewsAcincoComponent from "./news/create.news.component";
import CreateUserAcincoComponent from "./used/create.used.component";
import { useCreateNewsAcincoContext } from "./news/provider/createNewsAcinco.provider";
import { useCreateUsedAcincoContext } from "./used/provider/createUsedAcinco.provider";
import SelectFlowComponent from "./components/select-flow.component";
import RecoverStep from "./components/recover.component";
import CreateSimplyComponent from "./simply/create-simply.component";
import CreateSimplyAcincoProvider from "./simply/provider/createSimplyAcinco.provider";

const CreateAcincoComponent = () => {
  const { flow, step } = useCreateAcincoContext();
  const { step: stepNews } = useCreateNewsAcincoContext();
  const { step: stepUsed } = useCreateUsedAcincoContext();

  return (
    <>
      {step < 5 ? (
        <div
          className={`mx-auto w-11/12 md:w-2/3 lg:px-10 ${step !== 3 && "rounded-xl bg-white py-5 shadow-xl"}`}
        >
          <div className="mx-auto w-5/6 overflow-hidden pt-10 lg:w-3/4">
            {step === 1 && <LoginStepComponent />}
            {step === 2 && <Code2FAStepComponent />}
            {step === 3 && <SelectFlowComponent />}
            {step === 4 && <RecoverStep />}
          </div>
        </div>
      ) : (
        <>
          <div
            className={`flex w-full md:mt-20 md:flex-col lg:mt-20 xl:mt-20 xl:flex-row 2xl:mt-0 ${stepUsed === 3 && "md:mt-96 lg:mt-96 xl:mt-80"} ${stepNews === 2 && "md:mt-96 lg:mt-96 xl:mt-80"}`}
          >
            <div className="w-full rounded-xl bg-white py-5 shadow-xl md:-mt-1 lg:px-10 xl:mt-10">
              <div className="mx-auto w-5/6 overflow-hidden pt-10 lg:w-3/4">
                <CreateSimplyAcincoProvider>
                  <CreateSimplyComponent />
                </CreateSimplyAcincoProvider>
                {/*   {flow === "new" && <CreateNewsAcincoComponent />}
                {flow === "used" && <CreateUserAcincoComponent />} */}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default CreateAcincoComponent;
